import React from 'react';
import ReactDOM from 'react-dom/client';
import LocalizedStrings from "react-localization";

let strings = new LocalizedStrings({
    ru: {
        title: "Обратный звонок",
        name: "Имя",
        phone: "Номер телефона",
        personal_data: 'условия обработки персональных данных',
        by_clicking: 'Нажимая "Отправить", Вы подтверждаете',
        phone_or_name: 'Пожалуйста, укажите номер телефона и имя.',
        try_again_later: 'Произошла ошибка. Пожалуйста, повторите позже или свяжитесь с нами.',
        submit: "Отправить",
    },
    et: {
        title: "Helista tagasi",
        name: "Nimi",
        phone: "Telefoninumber",
        personal_data: 'isikuandmete töötlemise tingimused',
        by_clicking: 'Klõpsates "Esita", kinnitad',
        phone_or_name: 'Sisestage telefoninumber ja nimi.',
        try_again_later: 'Tekkis viga. Proovige hiljem uuesti või võtke meiega ühendust.',
        submit: "Esita",
    }
});

export class PopupContact extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            phone: '',
            name: '',
            validationError: '',
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePhoneChanged = this.handlePhoneChanged.bind(this);
        this.handleNameChanged = this.handleNameChanged.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.openPopup = this.openPopup.bind(this);

        document.addEventListener('click', (e) => {
            if (e.target.dataset.modalShow === 'popup-contact') {
                e.preventDefault();
                this.openPopup();
            }
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.state.phone === '' && this.state.name === '') {
            this.setState(() => ({
                validationError: strings.phone_or_name
            }));
        } else {
            fetch('/v2/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    phone: this.state.phone,
                    name: this.state.name,
                })
            }).then((response) => {
                if (response.ok) {
                    try {
                        gtag('event', 'application_applied', {
                            'event_category': 'first_train_registration',
                        });
                        fbq('trackCustom', 'ApplicationApplied');
                    } catch (e) {}

                    document.location.href = '/thanks';
                } else {
                    this.setState(() => ({
                        validationError: strings.try_again_later
                    }));
                }
            })
        }
    }

    handlePhoneChanged(event) {
        this.setState(() => ({
            phone: event.target.value,
            validationError: ''
        }));
    }

    handleNameChanged(event) {
        this.setState(() => ({
            name: event.target.value
        }));
    }

    closePopup() {
        this.setState(() => ({
            isOpen: false
        }));
    }

    openPopup() {
        this.setState(() => ({
            isOpen: true
        }));
    }

    render() {

        strings.setLanguage(localStorage.getItem('language'));

        return <>
            <div tabIndex="-1" aria-hidden="true"
                 id="popup-contact-modal"
                 className={"fixed z-[999] inset-0 overflow-y-auto w-full translate-y-5 shadow-2xl" + (!this.state.isOpen ? ' hidden' : '')}>
                <div className="relative  h-full lg:max-w-[412px] max-w-[288px] md:h-auto mx-auto">
                    <div className="relative bg-white rounded-[20px] shadow dark:bg-gray-700">
                        <button type="button"
                                onClick={this.closePopup}
                                className="absolute top-4 right-4 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                                data-modal-hide="authentication-modal">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.9999 18.9999L1 1" stroke="#808080" strokeWidth="2" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                                <path d="M19.0001 1L1 19.0001" stroke="#808080" strokeWidth="2" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                            </svg>

                            <span className="sr-only">Close modal</span>
                        </button>
                        <div className="lg:p-14 p-5">
                            <h3 className="mb-4 lg:mt-6 mt-12 lg:text-3xl text-xl font-medium text-dark-main dark:text-white text-center">{strings.title}</h3>
                            {this.state.validationError !== '' && (
                                <div className="text-red-800 text-center mb-2">
                                    {this.state.validationError}
                                </div>
                            )}
                            <form className="space-y-5" action="#" method="post" onSubmit={this.handleSubmit}>
                                <div>
                                    <label htmlFor="name"
                                           className="block mb-2 text-sm font-medium text-dark-main dark:text-white">{strings.name}</label>
                                    <input type="text" name="name" onChange={this.handleNameChanged} id="name"
                                           className="border border-input-border text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"/>
                                </div>
                                <div>
                                    <label htmlFor="phone"
                                           className="block mb-2 text-sm font-medium text-dark-main dark:text-white">{strings.phone}</label>
                                    <input type="tel" name="phone" id="phone" onChange={this.handlePhoneChanged}
                                           className="border border-input-border text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"/>
                                </div>

                                <button type="submit"
                                        className="w-full mb-10 text-white bg-blue-main hover:bg-blue-main focus:ring-4 focus:outline-none focus:ring-blue-300 font-semibold rounded-full text-sm px-5 py-3 text-center font-open-sans">{strings.submit}</button>
                                <div className="text-sm font-light text-dark-main dark:text-gray-300 text-center">
                                    {strings.by_clicking} <a href="/police-cookies" target="_blank"
                                                             className="text-link-main hover:underline dark:text-blue-500">{strings.personal_data}</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>;
    }
}

if (document.getElementById('popup-contact')) {
    const root = ReactDOM.createRoot(document.getElementById('popup-contact'));
    root.render(<PopupContact/>);
}
